import React from 'react';
import notificationsSet from './constants/notificationsSet';

import ModalPreviewer from '@components/ModalPreviewer/ModalPreviewer';
import { ShowCase, Preview, Controls } from '@components/ShowCase';

const Notifications = () => (
  <section>
    <article>
      <ul className="showcase-list">
        {
          notificationsSet.map((notificationPreview, i) => (
            <li key={`notification-showcase-${i}`}>
              <ShowCase codeTemplate={notificationPreview.codeTemplate}>
                <Preview className={notificationPreview.previewClass}>
                  {
                    notificationPreview.imagePath
                      ? <ModalPreviewer
                          previewText="Preview Notification"
                          className={notificationPreview.modalPreviewClassName}
                          imagePath={`notifications/${notificationPreview.imagePath}`}
                        >
                          { notificationPreview.component }
                        </ModalPreviewer>
                      :  notificationPreview.component 
                  }
                </Preview>
                <Controls optionsGroup={notificationPreview.optionsGroup}  />
              </ShowCase>
            </li>
          ))
        }
      </ul>
    </article>
  </section>
);

Notifications.displayName = 'NotificationsPage';

export default Notifications;


// WEBPACK FOOTER //
// ./src/containers/components/Notification/Notifications.js